// extracted by mini-css-extract-plugin
export var container = "style-module--container--be4e6";
export var edm = "style-module--edm--d48d3";
export var gift = "style-module--gift--dbcd9";
export var info = "style-module--info--77cbf";